export default __webpack_public_path__ + "static/media/trash_in_fire.b5db61eb.jpg";